import React from "react";
import ChargeInsertAutoForm from "./ChargeInsertAutoForm";

const ChargeInsertAuto = () => {
    return (
        <div className="flex flex-col space-y-8">
            <ChargeInsertAutoForm />
        </div>
    );
};

export default ChargeInsertAuto;
